module.exports = __webpack_public_path__ + "media/assets/mobileHeaderBtn-0d1c92bf568e8c51a9202d278dd692cc.png";